import { z } from 'zod';

export const formSchema = z.object({
  invoiceNumber: z.string().optional(),
  companyIds: z.array(z.string()).optional(),
  expirationDate: z
    .object({
      from: z.date().optional(),
      to: z.date().optional(),
    })
    .optional(),
  productIds: z.array(z.string()).optional(),
});

export type FormSchema = z.infer<typeof formSchema>;